export enum SizeTypes {
    free = 'free',
    xs = 'xs',
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl',
}

export enum DisplayTypes {
    flex = 'flex',
    inline = 'inline',
}
